import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LiveOperations } from "@/components/LiveOperations";
import { MEDIA } from "@/lib/company";

const CASES = [
  { img: MEDIA.terminalAerial, tag: "Container Yard", title: "Port of Felixstowe Hub", text: "Aerial sort yard handling 40,000 TEU/month with live gate-in tracking." },
  { img: MEDIA.cargoPlane, tag: "Air Freight", title: "East Midlands Air Gateway", text: "Priority overnight air lane with ramp-to-timeline status in seconds." },
  { img: MEDIA.warehouseTablet, tag: "Fulfilment", title: "Manchester Distribution Centre", text: "Tablet-driven scanning pushes every parcel event to the public timeline." },
  { img: MEDIA.courierVan, tag: "Last Mile", title: "London Metro Courier Network", text: "Dense urban routes with proof-of-delivery at the doorstep." },
  { img: MEDIA.shipPort, tag: "Ocean", title: "Intermodal Sea Freight", text: "Global container shipping connected to inland road & rail." },
  { img: MEDIA.courierWalk, tag: "Experience", title: "Door-to-Door Handoff", text: "Human-first delivery backed by machine-precise tracking." },
];

export default function PortfolioPage() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100">
      <Navbar />
      <section className="relative overflow-hidden">
        <img src={MEDIA.containerStacks} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/92 via-slate-950/85 to-[#0B0F17]" />
        <div className="relative mx-auto max-w-5xl px-4 py-24 sm:px-6">
          <p className="mb-3 text-xs font-mono uppercase tracking-[0.25em] text-orange-400">Our Portfolio</p>
          <h1 className="text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
            Proof in every<br /><span className="text-orange-500">mile moved.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base text-slate-300">
            A look across the Go Deliver network — the hubs, gateways and routes behind the tracking numbers.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CASES.map((c) => (
            <article
              key={c.title}
              data-testid={`portfolio-card-${c.tag.toLowerCase().replace(/\s+/g, "-")}`}
              className="group overflow-hidden rounded-2xl border border-white/10 bg-slate-900/60"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={c.img} alt={c.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <span className="absolute left-3 top-3 rounded-full bg-orange-600 px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-white">
                  {c.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold">{c.title}</h3>
                <p className="mt-1 text-sm text-slate-400">{c.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <LiveOperations />
      <Footer />
    </div>
  );
}
